import axios from 'axios';

export const imageFileToResizedDataUrl = async (file: File) => {
  const dataUrl = await readFileAsDataUrl(file);
  const img = await loadDataUrlToImg(dataUrl);
  return await imgMaxSizePx(img);
};

export const imageUrlToImgElement = async (url: string) => {
  const file = await getImageFile(url);
  return imageFileToImgElement(file);
};

export const imageFileToImgElement = async (file: File) => {
  const dataUrl = await readFileAsDataUrl(file);
  return await loadDataUrlToImg(dataUrl);
};

const getImageUrl = (path: string) => {
  if (!path) {
    return path;
  }

  const pieces = path.split('~');

  if (pieces.length > 1) {
    return pieces[0];
  }

  return path;
};

export const getImageFile = async (photoPath: string) => {
  try {
    return axios
      .get<File>(getImageUrl(photoPath), { responseType: 'blob' })
      .then(resp => resp.data);
  } catch (e) {
    console.log(e);
    return new File([], ''); // return empty file on error
  }
};

export const readFileAsDataUrl = (fileRef: File): Promise<string> => {
  const fileReader = new FileReader();

  return new Promise((resolve, reject): void => {
    fileReader.onerror = (): void => {
      fileReader.abort();
      reject(new DOMException('Problem parsing input file.'));
    };

    fileReader.onload = (): void => {
      if (typeof fileReader.result === 'string') {
        resolve(fileReader.result);
      } else {
        reject(new DOMException('Problem parsing input file.'));
      }
    };

    if (fileRef) {
      fileReader.readAsDataURL(fileRef);
    } else {
      //this should never happen
      console.error('fileRef is undefined');
    }
  });
};

export const loadDataUrlToImg = (dataUrl: string): Promise<HTMLImageElement> => {
  const img = new Image();
  img.crossOrigin = 'anonymous';

  return new Promise((resolve, reject): void => {
    img.onerror = (): void => {
      reject(new DOMException('Problem loading input file.'));
    };

    img.onload = (): void => {
      resolve(img);
    };

    if (img) {
      img.setAttribute('src', dataUrl);
    }
  });
};

interface ResizeImgProps {
  height: number;
  img: HTMLImageElement;
  width: number;
}
const resizeImg = ({ height, img, width }: ResizeImgProps): string => {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const canvas2d = canvas.getContext('2d');
  if (canvas2d) {
    canvas2d.drawImage(img, 0, 0, width, height);
  }

  return canvas.toDataURL('image/jpeg');
};

export const imgMaxSizePx = (img: HTMLImageElement, maxSize = 2500): string => {
  let { height, width } = img;

  if (width > height) {
    if (width > maxSize) {
      height *= maxSize / width;
      width = maxSize;
    }
  } else {
    /* eslint-disable no-lonely-if */
    if (height > maxSize) {
      width *= maxSize / height;
      height = maxSize;
    }
    /* eslint-enable no-lonely-if */
  }

  return resizeImg({ height, img, width });
};
